/**
 * Real API implementation for Current User (GET /users/me).
 */

import { apiClient } from '../apiClient';

const USERS_ME_PATH = '/users/me';

export const getCurrentUser = async () => {
  const response = await apiClient.get(USERS_ME_PATH);
  return response.data;
};
